import { jsx as _jsx } from "react/jsx-runtime";
import { planToMermaid } from "grafast/mermaid";
import mermaid from "mermaid";
import { useEffect, useMemo } from "react";
let initialized = false;
const MermaidReal = ({ plan }) => {
    const diagram = useMemo(() => planToMermaid(plan), [plan]);
    useEffect(() => {
        if (!initialized) {
            initialized = true;
            mermaid.initialize({
                startOnLoad: true,
                maxTextSize: 1000000,
                maxEdges: 1000,
            });
        }
        if (diagram) {
            mermaid.contentLoaded();
        }
    }, [diagram]);
    return (_jsx("div", { className: "mermaid", children: diagram }, diagram));
};
export default MermaidReal;
//# sourceMappingURL=MermaidReal.js.map